import React from "react";
import { Button, CardActions, CardContent, Grid, Typography } from "@material-ui/core";
import { PasswordField } from "$components/core";
import { useStyles } from "../styles";
import { useSetPasswordState } from "./useSetPasswordState";
import { useLiterals } from "$hooks/Translate/useLiterals";
import { IUser } from "@djordjeandjelkovic/medgress_common_react_modules";

interface IProps {
    user: IUser | undefined;
}

const SetPassword = (props: IProps) => {
    const classes = useStyles();
    const getLiteral = useLiterals();

    const [ { password, confirmPassword }, { handleChange, handleSetPassword }, ] = useSetPasswordState(props);

    return (
        <>
            <Typography variant="h4" className={classes.title}>
                {getLiteral("user_profile.menu.set_password")}
            </Typography>
            <CardContent className={classes.cardContent}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <PasswordField
                            name="new-password"
                            label={getLiteral("user_profile.user_details.form.change_password.new_password")}
                            onChange={handleChange}
                            value={password || ""}
                            variant="outlined"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <PasswordField
                            name="confirm-password"
                            label={getLiteral(
                                "user_profile.user_details.form.change_password.confirm_password"
                            )}
                            onChange={handleChange}
                            value={confirmPassword || ""}
                            variant="outlined"
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </CardContent>
            <CardActions className={classes.cardActions}>
                <Button
                    variant="contained"
                    color="primary"
                    className={classes.updateButton}
                    onClick={handleSetPassword}>
                    {getLiteral("common.button.update")}
                </Button>
            </CardActions>
        </>
    );
};

export { SetPassword };
